import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const taxDeclarationCombined = atom({
  key: "taxDeclarationCombined",
  default: {
    dateOfDeclaration: new Date(),
    isEligibleTwo: false,
    isEligibleThree: false,
    isEligible: false,
    dependents: [],
    applyAlone: false,
    applyTogether: false,
    noRequestRelief: false,
    taxReliefAmount: 0,
    taxReliefNumberOfChild: 0,
    spouseName: "",
    spouseTaxNumber: "",
    spouseEmployerName: "",
    spouseEmployerTaxNumber: "",
  },
  effects_UNSTABLE: [ocPersistAtom],
});
